import React from 'react';
import Navigation from './Navigation';
import { NavLink } from 'react-router-dom';
import { safeJsonParse } from '../../utils/safeJsonParse';

class Header2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            logo: require('./../../images/property_logo.png'),
            isLoggedIn: false,
            userRole: null
        };
    }

    state = { isSearchActive: false };

    handleSearchToggle = () => {
        this.setState({ isSearchActive: !this.state.isSearchActive });
    };

    componentDidMount() {

        const handleScroll = () => {
            const offset = window.scrollY;

            const stickyheader = document.querySelector('.sticky-header ');

            if (offset >= 100) {
                stickyheader.classList.add('is-fixed');
                stickyheader.classList.add('color-fill');

            } else {
                stickyheader.classList.remove('is-fixed');
                stickyheader.classList.remove('color-fill');
            }
        }

        window.addEventListener('scroll', handleScroll);

        window.updateTopMostParent = (logopath) => {
            this.setState({ logo: logopath });
        };
        
        // Check auth status for account link
        this.checkAuthStatus();
    }
    
    checkAuthStatus = () => {
        const authData = localStorage.getItem('infrioAuth');
        const auth = safeJsonParse(authData, null);
        if (auth && typeof auth === 'object') {
            this.setState({ isLoggedIn: true, userRole: auth.role });
        } else {
            this.setState({ isLoggedIn: false, userRole: null });
        }
    }

    render() {

        const isSearchActive = this.state.isSearchActive;

        return (
            <>
                <style>{`
                    @media (max-width: 768px) {
                        .top-bar {
                            display: none !important;
                        }
                        .mobile-drawer-top-items {
                            display: block !important;
                        }
                    }
                    @media (min-width: 769px) {
                        .mobile-drawer-top-items {
                            display: none !important;
                        }
                    }
                `}</style>
                <header className="site-header nav-wide nav-transparent mobile-sider-drawer-menu">
                    <div className="top-bar sx-bg-secondry">
                        <div className="container">
                            <div className="d-flex justify-content-between ">
                                <ul className="list-unstyled e-p-bx text-white" style={{ fontSize: '15px', marginBottom: 0 }}>
                                    <li style={{ fontSize: '15px' }}>Mail Us : info@infrioindia.com</li>
                                    <li style={{ fontSize: '15px' }}>Call Us : +91 90014 57000</li>
                                </ul>
                            
                                <ul className="list-unstyled e-p-bx text-white d-flex align-items-center m-b0" style={{ gap: '20px', fontSize: '15px' }}>
                                    {this.state.isLoggedIn ? (
                                        <li>
                                            <NavLink 
                                                to={this.state.userRole === 'normal' ? '/user-account' : '/partner-account'} 
                                                className="text-white"
                                                style={{ textDecoration: 'none', fontWeight: 500, fontSize: '15px' }}
                                            >
                                                My Account
                                            </NavLink>
                                        </li>
                                    ) : (
                                        <>
                                            <li>
                                                <NavLink to="/login" className="text-white" style={{ textDecoration: 'none', fontWeight: 500, fontSize: '15px' }}>
                                                    Login
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/register" className="text-white" style={{ textDecoration: 'none', fontWeight: 500, fontSize: '15px' }}>
                                                    Register
                                                </NavLink>
                                            </li>
                                           
                                            {/* <li>
                                                <NavLink to="/register" state={{ role: 'partner' }} className="text-white" style={{ textDecoration: 'none', fontWeight: 500, fontSize: '15px' }}>
                                                    Become a Partner
                                                </NavLink>
                                            </li> */}
                                        </>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="sticky-header main-bar-wraper navbar-expand-lg">
                        <div className="main-bar">
                            <div className="container clearfix">
                                <div className="logo-header-check">
                                    <div className="logo-header-inner logo-header-one">
                                        <NavLink to={"/"}>
                                            <img src={this.state.logo} alt="Inteshape" />
                                        </NavLink>
                                    </div>
                                </div>
                                {/* NAV Toggle Button */}
                                <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button" className="navbar-toggler collapsed">
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar icon-bar-first" />
                                    <span className="icon-bar icon-bar-two" />
                                    <span className="icon-bar icon-bar-three" />                      </button>
                                {/* EXTRA NAV */}
                                {/* <div className="extra-nav">
                                    <div className="extra-cell">
                                        <NavLink to={"#"} onClick={this.handleSearchToggle}>
                                            <i className="fa fa-search" />
                                        </NavLink>
                                    </div>
                                </div> */}
                                {/* EXTRA Nav */}
                                {/* MAIN NAVIGATION */}
                                <div className="header-nav nav-dark navbar-collapse collapse justify-content-center collapse">
                                    <Navigation isLoggedIn={this.state.isLoggedIn} userRole={this.state.userRole} />
                                </div>
                                {/* SITE SEARCH */}
                                <div id="search" className={isSearchActive ? "open" : null}>
                                    <span className="close" onClick={this.handleSearchToggle} />
                                    <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                                        <div className="input-group">
                                            <input defaultValue="" name="q" type="search" placeholder="Type to search" />
                                            <span className="input-group-btn"><button type="button" className="search-btn"><i className="fa fa-search arrow-animation" /></button></span>                                  </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

            </>
        );
    };
};

export default Header2;
